import serviceUrls from 'src/constants/serviceUrls';
import axiosRequest from 'src/helpers/axiosRequest';

export function fetchSSIList(body = {}) {
  return axiosRequest('post', serviceUrls.SSI_GET_LIST, body);
}

export function fetchEngagementList() {
  return axiosRequest('get', serviceUrls.SSI_GET_ENGAGEMENTLIST);
}

export function fetchInitationTypeList() {
  return axiosRequest('get', serviceUrls.SSI_GET_INITIATIONTYPELIST);
}

export function fetchEmployeeListByName(name = '', engagementId = '') {
  return axiosRequest('get', serviceUrls.SSI_GET_EMPLOYEELIST_BY_NAME, { EngagementId: engagementId, searchText: name });
}

export function fetchPassportCountryList() {
  return axiosRequest('get', serviceUrls.SSI_GET_PASSPORT_COUNTRYLIST);
}

export function fetchRelationshipStatusList() {
  return axiosRequest('get', serviceUrls.SSI_GET_RELATIONSHIPSTATUS_LIST);
}

export function fetchEmployeeTypeList() {
  return axiosRequest('get', serviceUrls.SSI_GET_EMPLOYEETYPE_LIST);
}

export function fetchServiceTypeList(year = '', engagementCode = []) {
  return axiosRequest('post', serviceUrls.SSI_GET_SERVICETYPE_LIST, { Year: year, EngagementCode: engagementCode });
}

export function fetchCountryList(year = '', serviceType = '') {
  return axiosRequest('post', serviceUrls.SSI_GET_COUNTRY_LIST, { Year: year, ServiceTypeAb: serviceType });
}

export function fetchEmployeeList() {
  return axiosRequest('post', serviceUrls.SSI_GET_EMPLOYEELIST_FORDROPDOWN);
}

export function fetchServiceDetails(year = '', assigneeServicePlanGlobalId = '') {
  return axiosRequest('get', serviceUrls.SSI_GET_DETAILS, { year, assigneeServicePlanGlobalId });
}

export function addNewEmployee(employeeData) {
  return axiosRequest('post', serviceUrls.SSI_ADD_NEWEMPLOYEE, employeeData);
}

export function exportSSIData(data = {}) {
  return axiosRequest('post', serviceUrls.SSI_EXPORT, data);
}

export function getSSIFiltersAPI() {
  return axiosRequest('get', serviceUrls.SSI_GET_FILTERS);
}
